import "ress";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import "@/assets/styles/kyra.less";
import "@/assets/styles/main.less";
import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import withUUID from "vue-uuid";
import { setAutoFreeze } from "immer";
import clickOutside from "./clickOutside";
import testIdDirective from "./directives/testId";
setAutoFreeze(false);

const app = withUUID(createApp(App));
app.use(store);
app.use(router);

// app.config.productionTip = false;

import "@aws-amplify/ui-vue/styles.css";
import AmplifyVue from "@aws-amplify/ui-vue";
import awsconfig from "./aws-exports";
import { Amplify } from "aws-amplify";

Amplify.configure(awsconfig);
app.use(AmplifyVue);
// Internationalization
import en_US from "./i18n/en_US";
import de from "./i18n/de";

export const i18n = createI18n({
  locale: "en_US",
  allowComposition: true,
  messages: { en_US, de },
});

app.use(i18n);

app.directive("outside-click", clickOutside);

// import { I18n } from "aws-amplify";
// import { Translations } from "@aws-amplify/ui-components";

// I18n.putVocabulariesForLanguage("de", {
//   [Translations.SIGN_IN_HEADER_TEXT]: "Willkommen zurück",
//   [Translations.SIGN_IN_ACTION]: "Anmelden",
//   [Translations.USERNAME_LABEL]: "Benutzername",
//   [Translations.USERNAME_PLACEHOLDER]: "Benutzername eingeben",
//   [Translations.PASSWORD_LABEL]: "Passwort",
//   [Translations.PASSWORD_PLACEHOLDER]: "Passwort eingeben",
//   [Translations.FORGOT_PASSWORD_TEXT]: "Passwort vergessen ?",
//   [Translations.RESET_PASSWORD_TEXT]: "Passwort zurücksetzen",
//   [Translations.NO_ACCOUNT_TEXT]: "Kein Konto ?",
//   [Translations.CREATE_ACCOUNT_TEXT]: "Konto erstellen",
//   [Translations.EMAIL_LABEL]: "E-Mail-Adresse",
//   [Translations.EMAIL_PLACEHOLDER]: "E-Mail-Adresse eingeben",
//   [Translations.SIGN_UP_HAVE_ACCOUNT_TEXT]: "Haben Sie ein Konto?",
//   [Translations.SIGN_UP_SUBMIT_BUTTON_TEXT]: "Konto erstellen",
//   [Translations.SIGN_UP_HEADER_TEXT]: "Erstelle ein neues Konto",
//   [Translations.SIGN_IN_TEXT]: "Anmelden",
//   "Incorrect username or password.": "Falscher Benutzername oder Passwort.",
//   "Password did not conform with policy: Password not long enough":
//     "Passwort entspricht nicht den Richtlinien: Passwort nicht lang genug.",
//   "User is not confirmed.": "Benutzer ist nicht bestätigt.",
//   "User does not exist.": "Benutzer existiert nicht.",
// });

// export default new Vue({
//   router,
//   store,
//   i18n,
//   render: (h) => h(App),
// }).$mount("#app");
app.directive("test-id", testIdDirective);
app.mount("#app");
